module.exports = __webpack_public_path__ + "static/media/img-keelo-product-3.b543cb82.png";